





































import { Component, Inject } from "vue-property-decorator";
import Context from "@/mixins/context";

import {
  ITaxTemplatesProvider,
  ITaxTemplatesProviderMethods
} from "@/models/providers/tax";

@Component({
  components: {
    "tax-template-grid-item": () =>
      import("@/components/app/global/tax/templates/taxTemplateGridItem.vue")
  }
})
export default class TaxTemplatesGridView extends Context {
  // Inject
  @Inject({ from: "taxTemplatesProvider" })
  public taxTemplatesProvider!: () => ITaxTemplatesProvider;

  @Inject({ from: "taxTemplatesProviderMethods" })
  public $taxTemplatesMethods!: ITaxTemplatesProviderMethods;

  public get $taxTemplatesData() {
    return this.taxTemplatesProvider();
  }

  // Computed

  public get skeletonSize() {
    return (
      this.$taxTemplatesData.table.total ||
      (this.$store.getters["ui/isMobile"] ? 2 : 6)
    );
  }

  public get showEmptyState() {
    const { loading, total } = this.$taxTemplatesData.table;
    return !loading && !total;
  }
}
